import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";

import HopkinsZiplyneApp from "./components/HopkinsZiplyneApp";

import "normalize.css/normalize.css";
import "./styles/styles.scss";
import Auth from "./components/Auth";

ReactGA.initialize("G-39QSRFWQ7T");

export const App = () => {
  const history = useHistory();
  const pathName = history.location.pathname;
  useEffect(() => {
    const pageURL = window.location.pathname + window.location.search;
    ReactGA.pageview(pageURL);
  }, [pathName]);
  return (
    <Auth>
      <HopkinsZiplyneApp />
    </Auth>
  );
};
